import getAppState from 'app-state';
/**
 * Returns the current user ID or null if there is no current user
 */
export default (): null | string => {
  const appState = getAppState('currentUser') as { userFound: boolean; userId?: string };
  // FIXME: We don't need a dedicated `userFound` flag. All we need to do is check for the existence of `userId`
  return appState.userFound ? appState.userId : null;
};
